// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"84968d22","453":"26fc0488","455":"c39e5d5c","977":"52eaa0c9"}[chunkId] + ".chunk.js";
};